import { Card } from '@/types/game';

/** Repeated castle layers share exact bounds; only their highest opaque tile needs paint. */
export const paintedCards = (cards: Card[], hiddenIds: string[] = []): Card[] => {
  const hidden = new Set(hiddenIds), occupied = new Set<string>(), keep = new Set<string>();
  for (const card of cards.filter(c => c.status === 0).sort((a, b) => b.zIndex - a.zIndex)) {
    const bounds = card.x + ',' + card.y + ',' + (card.size ?? 92);
    // Return-flight targets must remain queryable and cannot hide the visible tile below.
    if (hidden.has(card.id)) { keep.add(card.id); continue; }
    if (occupied.has(bounds)) continue;
    occupied.add(bounds); keep.add(card.id);
  }
  return cards.filter(card => keep.has(card.id));
};
